import { useCallback } from 'react';
import { useScope } from '@/contexts/ScopeContext';
import { configurationMatchesPhaseView } from './phaseConfigurationView';

export default function usePhaseConfigurationView(domain) {
  const { phaseScope } = useScope();
  const ready = phaseScope?.ready !== false;
  const phaseKey = JSON.stringify(phaseScope?.configurationPhaseIds ?? phaseScope?.phaseIds ?? []);
  const matches = useCallback(definition => ready && configurationMatchesPhaseView(
    definition, JSON.parse(phaseKey), domain?.phaseApplicability), [ready, phaseKey, domain?.phaseApplicability]);
  const filter = useCallback(definitions => (definitions || []).filter(matches), [matches]);
  return { matches, filter, ready, filtered: phaseKey !== '[]' };
}
